import React from 'react'

const AnimationReel = () => (
  <div>
    <div className="row width-container center-image">
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/tIgV42gfT-A" allowFullScreen></iframe>
      </div>
    </div>
  </div>
)

export default AnimationReel;



// WEBPACK FOOTER //
// ./src/pages/animation/animation-reel.js